import { Typography } from "@material-ui/core";
import React from "react";
import AdminSecuritySearchResults from "./AdminSecuritySearchResults";

export default function AdminSecurity() {
  return (
    <div>
      <Typography variant="h2" style={{ margin: "1rem 0" }}>
        Security Logs
      </Typography>
      <AdminSecuritySearchResults />
    </div>
  );
}
